import React from 'react'
// @ts-ignore
import classnames from 'classnames'
import { ImageTwoCompoundProps } from './ImageTwoCompound.types'

export const ImageTwoCompound = (props: ImageTwoCompoundProps) => {
  const { imageDesktop, imageMobile, shouldGrow } = props

  const isMobileTablet = () => {
    return window.innerWidth <= 1024 ? true : false
  }
  const getProperty = (property: 'src' | 'alt' | 'title' | 'imagePosition' | 'url') => {
    const imageDesk = imageDesktop || {}
    const imageMob = imageMobile || {}
    if (isMobileTablet()) {
      return property in imageMob ? imageMob[property] : imageDesk[property]
    }
    return imageDesk[property]
  }
  return (
    <figure className={`image-block${shouldGrow ? ' u-flexGrow' : ''}`}>
      {getProperty('url') ? (
        <a className='u-inlineBlock' href={getProperty('url')}>
          <img
            className={classnames({ 'u-sizeFull': getProperty('imagePosition') === 'full' })}
            src={getProperty('src')}
            alt={getProperty('alt')}
            title={getProperty('title')}
          />
        </a>
      ) : (
        <img
          className={classnames({ 'u-sizeFull': getProperty('imagePosition') === 'full' })}
          src={getProperty('src')}
          alt={getProperty('alt')}
          title={getProperty('title')}
        />
      )}
    </figure>
  )
}
